type ReadingTimeStats = {
  time: number;
  minutes: number;
};

type WordCountStats = {
  total: number;
};

export type ReadingTimeResult = ReadingTimeStats & {
  words: WordCountStats;
};

const defaultWordsPerMinute = 250;

const isAnsiWordBound = (c: string) => {
  return " \n\r\t".includes(c);
};

function countWords(text: string): WordCountStats {
  let words = 0;
  let start = 0;
  let end = text.length - 1;
  const isWordBound = isAnsiWordBound;

  // fetch bounds
  /* eslint-disable @typescript-eslint/no-non-null-assertion */
  while (isWordBound(text[start]!)) start += 1;
  while (isWordBound(text[end]!)) end -= 1;

  const normalizedText = `${text}\n`;

  // calculate the number of words
  for (let i = start; i <= end; i += 1) {
    if (
      !isWordBound(normalizedText[i]!) &&
      isWordBound(normalizedText[i + 1]!)
    ) {
      words += 1;
    }
  }
  /* eslint-enable @typescript-eslint/no-non-null-assertion */

  return { total: words };
}

function readingTimeWithCount(
  words: WordCountStats,
  wordsPerMinute: number
): ReadingTimeStats {
  // reading time stats
  const minutes = words.total / wordsPerMinute;
  const time = Math.round(minutes * 60 * 1000);
  const displayed = Math.ceil(parseFloat(minutes.toFixed(2)));

  return {
    minutes: displayed,
    time,
  };
}

export function readingTime(
  text: string,
  wordsPerMinute = defaultWordsPerMinute
): ReadingTimeResult {
  const words = countWords(text);
  return {
    ...readingTimeWithCount(words, wordsPerMinute),
    words,
  };
}
